// src/components/LongTailedRiverStingray.jsx
import React from 'react';
import '../../../css/float.css'; // "bob" animation
import '../../../css/glow.css';  // glow-light / glow-dark

/**
 * Stingray that gently bobs up & down (like the eel).
 */
export default function SwimmingLongTailedRiverStingray({
  width = 90,
  top = '85%',
  left = '20%',
  theme = 'light',
  highlight = false,
  bobDuration = '3s',
  onClick,
  zIndex = 10,
}) {
  const url = '/images/animals/50_80m/predator/long_tailed_river_stingray_right.png';

  const classes = [
    'bob', // vertical bob from float.css
    theme === 'light' ? 'glow-light' : 'glow-dark',
    highlight ? 'ring-4 ring-yellow-300 rounded-full' : '',
  ]
    .filter(Boolean)
    .join(' ');

  const handleKeyDown = (e) => {
    if (!onClick) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <div
      style={{
        position: 'absolute',
        top,
        left,
        transform: 'translate(-50%, -50%)',
        zIndex,
        pointerEvents: 'auto',
      }}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      aria-label="Long-Tailed River Stingray"
      onClick={onClick}
      onKeyDown={handleKeyDown}
    >
      <img
        src={url}
        alt="Long-Tailed River Stingray"
        className={classes}
        draggable={false}
        style={{
          width: `${width}px`,
          display: 'block',
          cursor: onClick ? 'pointer' : 'default',
          animationDuration: bobDuration, // override bob speed if desired
        }}
        onError={(e) =>
          console.warn('[LongTailedRiverStingray] image failed to load:', e.currentTarget.src)
        }
      />
    </div>
  );
}
